module.exports = __webpack_public_path__ + "static/media/hkust.24d441e4.png";